import Lottie from 'lottie-react';
import { ClientOnly } from '@epihub/web/src/components/ClientOnly';

export const LottieReact = (props: any) => {
  return (
    <ClientOnly>
      <Lottie {...props} />
    </ClientOnly>
  );
};
